import { Component, OnInit, OnDestroy } from '@angular/core';
import { ToastController, LoadingController, AlertController, ModalController } from '@ionic/angular';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { BehaviorSubject } from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import { UsersService } from '../../users.service';
import { BaseClass } from 'src/app/shared/classes/base';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-user-visibility-rules',
  templateUrl: './add-user-visibility-rules.component.html',
  styleUrls: ['./add-user-visibility-rules.component.scss'],
})
export class AddUserVisibilityRulesComponent extends BaseClass implements OnInit, OnDestroy {
  private searchSubject: BehaviorSubject<string> = new BehaviorSubject('');
  public users: any[] = [];

  constructor(
    private _router: Router,
    protected _toastController: ToastController,
    protected _translationService: TranslationService,
    private _loadingController: LoadingController,
    private _alertController: AlertController,
    private _modalController: ModalController,
    private _userService: UsersService) {
      super(_toastController, _translationService);
    }

  ngOnInit() {
    this.subscribeSearch();
  }

  public onChangeSearch(event) {
    this.searchSubject.next(event.srcElement.value);
  }

  public subscribeSearch() {
    this.searchSubject.pipe(
        distinctUntilChanged(),
        debounceTime(1000)
    ).subscribe(data => {
      if (data) {
        this._loadUsers(data);
      } else {
        this.users = [];
      }
    });
  }

  private async _loadUsers(searchValue: string = '') {
    const loading = await this._loadingController.create();
    await loading.present();

    this._userService.getUsers(1, 5, searchValue)
    .subscribe((response) => {
      this.users = response.data.users;
      loading.dismiss();
    }, (error) => {
      loading.dismiss();
      this.notifyError( error );
    });
  }

  public selectUser(index: number) {
    const user = this.users[index];
    this.dismiss();
    this._router.navigate(['users/visibility/' + user.userId ]);
  }

  public dismiss(): void {
    this._modalController.dismiss();
  }

  ngOnDestroy(): void {
    this.searchSubject.unsubscribe();
  }
}
